/**
 * applicationKind.ts — SSE meta application_kind 契约
 *
 * 职责：
 *     定义双轨 SSE 出口 kind 枚举与 mismatch 错误类型。
 *
 * 链路位置：
 *     createAgentxSseSource meta 握手校验。
 *
 * 当前裁剪范围：
 *     仅 agent_session / workflow；无自动推断。
 */
export type ApplicationKind = 'agent_session' | 'workflow';

export class ApplicationKindMismatchError extends Error {
  readonly name = 'ApplicationKindMismatchError';
  readonly expected: ApplicationKind;
  readonly actual: string | undefined;

  constructor(expected: ApplicationKind, actual: string | undefined) {
    super(
      `application_kind mismatch: expected ${expected}, got ${actual ?? '(missing)'}`,
    );
    this.expected = expected;
    this.actual = actual;
  }
}

export class MissingApplicationKindError extends Error {
  readonly name = 'MissingApplicationKindError';

  constructor() {
    super('application_kind missing in SSE meta frame');
  }
}
